import type { FactoringEntryInput } from "components/factoringModel";

export default function useCanShowField(
  desiredAmount: number,
  entries: FactoringEntryInput[],
  personalInfoConsent: boolean,
) {
  return (fieldName: string, entryIndex?: number, entryField?: string): boolean => {
    // For main form fields
    if (entryIndex === undefined && entryField === undefined) {
      switch (fieldName) {
        case 'desiredAmount':
          return true;
        case 'addEntryButton':
          return desiredAmount > 0;
        case 'submitButton':
          return desiredAmount > 0 && personalInfoConsent && entries.length > 0 && entries.every(entry =>
            !!entry.companyName &&
            !!entry.prefecture &&
            !!entry.city &&
            !!entry.address1 &&
            entry.billingAmount > 0 &&
            !!entry.paymentDate &&
            entry.imageFiles.length > 0
          );
        case 'notes':
          return desiredAmount > 0 && entries.length > 0;
        case 'personalInfoConsent':
          return desiredAmount > 0 && entries.length > 0;
        default:
          return false;
      }
    }

    // For entry fields
    if (entryIndex !== undefined && entryField !== undefined) {
      const entry = entries[entryIndex];
      if (!entry) return false;

      // First field in an entry is always visible
      if (entryField === 'companyName') return true;

      switch (entryField) {
        case 'corporateNumber':
          return !!entry.companyName;
        case 'postalCode':
        case 'prefecture':
          return !!entry.companyName;
        case 'city':
          return !!entry.companyName && !!entry.prefecture;
        case 'address1':
          return !!entry.companyName && !!entry.prefecture && !!entry.city;
        case 'address2':
          return !!entry.companyName && !!entry.prefecture && !!entry.city && !!entry.address1;
        case 'billingAmount':
          return !!entry.companyName && !!entry.prefecture && !!entry.city && !!entry.address1;
        case 'paymentDate':
          return !!entry.companyName && !!entry.prefecture && !!entry.city && !!entry.address1 && entry.billingAmount > 0;
        case 'isInvoiceIssued':
        case 'imageFiles':
          return !!entry.companyName && !!entry.prefecture && !!entry.city && !!entry.address1 && entry.billingAmount > 0 && !!entry.paymentDate;
        default:
          return false;
      }
    }

    return false;
  };
}
